
export type CallLiveEvidence = {
  bridgeConnected: boolean;
  bridgeSource: string;
  pushHealthy: boolean;
  firebaseTokenPresent: boolean;
  notificationChannelReady: boolean;
  incomingServiceReady: boolean;
  evidence: string[];
};

export function collectCallLiveEvidence(input: any = {}): CallLiveEvidence {
  const call = input?.call || input?.calls || input?.runtime?.calls || input || {};

  const bridgeConnected = Boolean(
    call.bridgeConnected ||
    call.incomingCallBridgeConnected ||
    call.bridge?.connected ||
    call.sessionEvidence?.bridgeConnected
  );

  const bridgeSource =
    call.bridgeSource ||
    call.bridge?.source ||
    call.sessionEvidence?.source ||
    'none';

  const pushHealthy = Boolean(
    call.pushHealthy ||
    call.notifications?.pushHealthy ||
    call.firebase?.pushHealthy
  );

  const firebaseTokenPresent = Boolean(
    call.firebaseToken ||
    call.fcmToken ||
    call.firebase?.token ||
    call.notifications?.fcmToken
  );

  const notificationChannelReady = Boolean(
    call.notificationChannelReady ||
    call.android?.notificationChannelReady ||
    call.notifications?.channelReady
  );

  const incomingServiceReady = Boolean(
    call.incomingServiceReady ||
    call.android?.incomingServiceReady ||
    call.manifest?.incomingCallServiceRegistered
  );

  return {
    bridgeConnected,
    bridgeSource,
    pushHealthy,
    firebaseTokenPresent,
    notificationChannelReady,
    incomingServiceReady,
    evidence: [
      `bridgeConnected=${bridgeConnected}`,
      `bridgeSource=${bridgeSource}`,
      `pushHealthy=${pushHealthy}`,
      `firebaseTokenPresent=${firebaseTokenPresent}`,
      `notificationChannelReady=${notificationChannelReady}`,
      `incomingServiceReady=${incomingServiceReady}`,
    ],
  };
}
